import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_ENV === 'prod' 
        ? process.env.VUE_APP_API_BASE_URL
        : 'https://api.tourobs.ch/api',
})

Vue.use(VueAxios, instance)

export default instance